// extracted by mini-css-extract-plugin
export default {"NavigationItem":"NavigationItem_NavigationItem__RupGX","active":"NavigationItem_active__wOoFL","NavigationItemIcon":"NavigationItem_NavigationItemIcon__k74AT"};